module.exports = "/images/8404187-blue_bg.png";